import store from '@/store/index'

async function isAuthenticated(to, from, next) {

  if (store.getters.isAuthenticated && store.getters.verifyEmail === false && to.name !== 'VerificaEmail') {
    if (to.name === 'VerificaEmailHash') {
      return next()
    } else {
      if (to.path != from.path)
        return next(`/verificar-email${window.location.search}`)
    }
  }

  const isClientOnly = store.getters.isClientOnly;

  // A permissão do colaborador depende do pai. O endpoint de painéis é o
  // bootstrap permitido para descobrir esse pai antes de consultar permissões.
  if (
    store.getters.isAuthenticated
    && store.getters.verifyEmail === true
    && isClientOnly
    && !store.getters.setPanel
  ) {
    await store.dispatch("bootstrapSubUserPanel");
  }

  let userPermissions = []
  if (store.getters.isAuthenticated && store.getters.getAllPermissionsNames && store.getters.getAllPermissionsNames.length) {
    userPermissions = await store.getters.getAllPermissionsNames;
  } else if (store.getters.isAuthenticated && (!isClientOnly || store.getters.setPanel)) {
    await store.dispatch("actionPermissions");
    userPermissions = await store.getters.getAllPermissionsNames;
  }

  if (store.getters.isAuthenticated) {
    store.dispatch("userRequest").catch(() => { });
  }

  const requiredPermissions = await to.meta.permissionName || null;
  const hasPermission = await userPermissions.includes(requiredPermissions);

  if (store.getters.isAuthenticated && (hasPermission || requiredPermissions === null)) {
    return next();
  } else if (store.getters.isAuthenticated && !hasPermission) {
    // Tenta redirecionar para a primeira rota que o usuário tem permissão.
    // Se não encontrar nenhuma rota conhecida (ex: usuário Client-only cujas
    // permissões não mapeiam para rotas de seller), redireciona para a rota
    // padrão do comprador. Sem esse fallback, next('/') causaria loop infinito
    // pois '/' redireciona de volta para '/dashboard', que exige permissão 'Dashboard'.
    const firstKnownRoute = routes[userPermissions[0]];
    const fallbackRoute = clientRoutes[userPermissions[0]] || clientFallback;
    let destination = firstKnownRoute || fallbackRoute;
    const query = to.query || {};
    // O convite chega em /dashboard/?code=&parent_id=. Quem cai em /compras
    // é entregue ao ADM novo pelo route-interceptor e o modal do Vue não abre.
    // /aceitar-convite permanece no Vue, sem sidebar e sem montar o Dashboard.
    if (destination === 'compras' && query.code && query.parent_id) {
      destination = 'aceitar-convite';
    }
    return next({
      path: '/' + destination,
      query: to.query,
    });
  }

  return next('/')
}

const authentication = isAuthenticated

// Rotas de seller — mapeadas por nome de permissão
const routes = {
  Dashboard: 'dashboard',
  Sales: 'vendas',
  Contracts: 'contratos',
  Commissions: 'comissoes',
  Products: 'produtos',
  Notes: 'central-de-notas',
  Links: 'links',
  Checkouts: 'checkouts',
  Reports: 'relatorios',
  Statements: 'extrato',
  Coupons: 'cupom',
  Leads: 'gestao-leads',
  Claims: 'reclamacoes',
  Integrations: 'integracoes',
  Showcase: 'vitrine',
  Recruitment: 'recrutamento',
}

// Rotas de comprador (role Client) — mapeadas por nome de permissão
const clientRoutes = {
  Purchase: 'compras',
}

// Rota de fallback para usuários autenticados sem nenhuma permissão mapeada em
// routes nem em clientRoutes. Evita o loop: next('/') → /dashboard → sem permissão
// → next('/') → stack overflow. Cobre Client-only (sem beta MY_PURCHASES) e também
// qualquer permissão de seller não registrada em routes.
// ATENÇÃO: ao adicionar novas permissões de seller, registre-as em routes acima.
const clientFallback = 'compras'

export default authentication
